!(function() {
    const searchBox = document.querySelector('.header__search-box')
    function searchViewAllListener() {
        const viewAllButtonInterval = setInterval(viewAllButtonIntervalTimer, 50)
        function viewAllButtonIntervalTimer() {
            const searchInput = document.querySelector('[data-header-search-input]')
            const submitButton = document.querySelector('button.ns-ac-footer-viewresults')
            if (submitButton) {
                submitButton.style.opacity = '1'
                if (searchInput.value) {
                    submitButton && submitButton.addEventListener('click', function(event) {
                        event.preventDefault()
                        if (searchInput.value) {
                            clearInterval(viewAllButtonInterval)
                            window.location.href = `/search?q=${encodeURIComponent(searchInput.value)}`
                        }
                    })
                }
            }
        }
    }
    searchBox && searchBox.addEventListener('click', searchViewAllListener)
})()